import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface CustomersIconProps {
  isSelected?: boolean;
  isHover?: boolean;
  style?: React.CSSProperties;
}

export default function CustomersIcon({
  isSelected = false,
  isHover = false,
  style = {},
  ...props
}: CustomersIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" style={{ width: `28px`, height: `28px`, ...style }}>
      <g>
        {isSelected ? (
          <>
            <path
              fill={RoutalPalette.primary40}
              d="m20.25,17.13c1.39-1.79,2.22-4.03,2.22-6.4C22.46,4.96,17.77.26,12,.26S1.54,4.96,1.54,10.72c0,5,3.53,9.29,8.42,10.26.18.22.49.85.66,1.21.49,1,.75,1.54,1.38,1.54.58,0,.87-.48,1.44-1.45.26-.44.74-1.25.87-1.36,2.34-.53,4.36-1.85,5.81-3.63l.18-.11-.05-.06ZM12,1.76c4.94,0,8.96,4.02,8.96,8.96,0,1.91-.62,3.71-1.69,5.2-1.92-2.21-4.37-3.49-6.98-3.6-2.76-.12-5.44,1.1-7.52,3.41l-.12.13c-1.03-1.47-1.62-3.24-1.62-5.14C3.04,5.78,7.06,1.76,12,1.76Z"
            />
            <path
              fill={RoutalPalette.primary40}
              d="m12,10.95c1.75,0,3.18-1.43,3.18-3.18s-1.43-3.18-3.18-3.18-3.18,1.43-3.18,3.18,1.43,3.18,3.18,3.18Z"
            />
          </>
        ) : isHover ? (
          <>
            <path
              fill={RoutalPalette.primary20}
              d="m20.25,17.13c1.39-1.79,2.22-4.03,2.22-6.4C22.46,4.96,17.77.26,12,.26S1.54,4.96,1.54,10.72c0,5,3.53,9.29,8.42,10.26.18.22.49.85.66,1.21.49,1,.75,1.54,1.38,1.54.58,0,.87-.48,1.44-1.45.26-.44.74-1.25.87-1.36,2.34-.53,4.36-1.85,5.81-3.63l.18-.11-.05-.06ZM12,1.76c4.94,0,8.96,4.02,8.96,8.96,0,1.91-.62,3.71-1.69,5.2-1.92-2.21-4.37-3.49-6.98-3.6-2.76-.12-5.44,1.1-7.52,3.41l-.12.13c-1.03-1.47-1.62-3.24-1.62-5.14C3.04,5.78,7.06,1.76,12,1.76Z"
            />
            <path
              fill={RoutalPalette.primary20}
              d="m12,10.95c1.75,0,3.18-1.43,3.18-3.18s-1.43-3.18-3.18-3.18-3.18,1.43-3.18,3.18,1.43,3.18,3.18,3.18Z"
            />
          </>
        ) : (
          <>
            <path
              fill={RoutalPalette.neutral60}
              d="m12,.36C6.23.36,1.54,5.05,1.54,10.82c0,5,3.53,9.29,8.42,10.26.18.22.49.85.66,1.21.49,1,.75,1.54,1.38,1.54.58,0,.87-.48,1.44-1.45.26-.44.74-1.25.87-1.36,4.73-1.06,8.16-5.36,8.16-10.21C22.46,5.05,17.77.36,12,.36Zm0,1.5c4.94,0,8.96,4.02,8.96,8.96,0,1.91-.62,3.71-1.69,5.2-1.92-2.21-4.37-3.49-6.98-3.6-2.76-.11-5.44,1.1-7.52,3.41l-.12.13c-1.03-1.47-1.62-3.24-1.62-5.14C3.04,5.88,7.06,1.86,12,1.86Zm1.98,17.71c-.66.15-1.13.88-1.83,2.06-.03.06-.07.11-.1.18-.03-.06-.06-.11-.08-.17-.57-1.16-.95-1.88-1.6-2-1.85-.34-3.48-1.24-4.73-2.51l.26-.29c1.78-1.97,4.02-3.01,6.35-2.92,2.25.09,4.38,1.25,6.05,3.25-1.16,1.16-2.64,2.01-4.32,2.39Z"
            />
            <path
              fill={RoutalPalette.neutral60}
              d="m12,11.04c1.75,0,3.18-1.43,3.18-3.18s-1.43-3.18-3.18-3.18-3.18,1.43-3.18,3.18,1.43,3.18,3.18,3.18Zm0-4.86c.93,0,1.68.75,1.68,1.68s-.75,1.68-1.68,1.68-1.68-.75-1.68-1.68.75-1.68,1.68-1.68Z"
            />
          </>
        )}
      </g>
    </SvgIcon>
  );
}
